function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/display-name
const Text = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    className = '',
    children,
    tag = 'span',
    size = 'lg',
    fontFamily = 'regular',
    color = '',
    style = {},
    ...restProps
  } = props;
  const TextTag = tag;
  const textClasses = classNames({
    [className]: !!className,
    [`sib-typo_text--${fontFamily}`]: !!fontFamily,
    [`sib-typo_text_size--${size}`]: !!size
  });
  const textColor = color || 'var(--sib-color_content-primary,#1f2d3d)';
  const textStyles = {
    color: textColor,
    ...style
  };
  return /*#__PURE__*/React.createElement(TextTag, _extends({
    className: textClasses,
    ref: ref,
    style: textStyles
  }, restProps), children);
});
Text.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  tag: PropTypes.oneOf(['span', 'p', 'div']),
  fontFamily: PropTypes.oneOf(['regular', 'interactive', 'bold']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  color: PropTypes.string,
  style: PropTypes.object
};
export default Text;